<template>
<div>
  <v-layout class="row">
    <v-col class="d-flex" cols="8">
      <v-text-field
        dense
        label="เครือ"
        outlined
      ></v-text-field>
  </v-col>
  <v-col class="d-flex" cols="2">
    <v-btn color="green" class="add_button" outlined> Add
      <!-- <v-icon>mdi-plus</v-icon> -->
    </v-btn>
  </v-col>
  </v-layout>
  <v-data-table
    :headers="headers"
    :items="desserts"
    class="elevation-1"
    disable-sort
  >
  <template v-slot:item.calories="{ item }">
    <v-chip :color="getColor(item.calories)" dark>{{ item.calories }}</v-chip>
  </template>
  <template v-slot:item.companyName="{ }">
      <div>
        <v-col cols="8">
          <v-select :items="itemCompany" outlined placeholder="select"></v-select>
        </v-col>
      </div>
    </template>
  <template v-slot:item.actions="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>
    </template>
  </v-data-table>
</div>
</template>
<script>
export default {
  data () {
    return {
      headers: [
        {
          text: 'ลำดับ',
          align: 'start',
          sortable: false,
          value: 'name'
        },
        { text: 'ชื่อบริษัท', value: 'companyName' },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      itemCompany: [
        'INET',
        'OGS'
      ],
      desserts: [
        {
          name: '1',
          companyName: 'INET'
        },
        {
          name: '2',
          companyName: 'OGS'
        }
      ]
    }
  },
  methods: {
    getColor (calories) {
      if (calories > 400) return 'red'
      else if (calories > 200) return 'orange'
      else return 'green'
    }
  }
}
</script>
